module.exports = __webpack_public_path__ + "img/WT-02_1125.6c81e943.png";